import React from 'react';

interface Cafe3DIconProps {
  size?: number;
  color?: string;
}

export const Cafe3DIcon = ({ size = 48, color = '#8B4513' }: Cafe3DIconProps) => {
  const darkerColor = adjustBrightness(color, -30);
  const lighterColor = adjustBrightness(color, 40);

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shadow */}
      <ellipse cx="30" cy="58" rx="14" ry="3" fill="rgba(0,0,0,0.2)" />
      {/* Saucer */}
      <ellipse cx="30" cy="52" rx="16" ry="5" fill={darkerColor} />
      <ellipse cx="30" cy="51" rx="16" ry="5" fill={color} />
      {/* Cup body */}
      <path d="M16 30 L18 48 C18 50 24 52 30 52 C36 52 42 50 42 48 L44 30 Z" fill={color} />
      {/* Cup right side highlight */}
      <path d="M38 30 L40 48 C40 49 42 48 42 48 L44 30 Z" fill={darkerColor} />
      {/* Cup top rim */}
      <ellipse cx="30" cy="30" rx="14" ry="5" fill={lighterColor} />
      {/* Coffee inside */}
      <ellipse cx="30" cy="31" rx="11" ry="3.5" fill={darkerColor} />
      {/* Handle */}
      <path d="M44 34 C50 34 52 38 52 42 C52 46 50 48 44 46" stroke={color} strokeWidth="3" fill="none" />
      <path d="M44 34 C50 34 52 38 52 42 C52 46 50 48 44 46" stroke={darkerColor} strokeWidth="2" fill="none" />
      {/* Steam */}
      <path d="M24 24 C24 20 26 18 24 14" stroke={lighterColor} strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.5" />
      <path d="M30 22 C30 18 32 16 30 12" stroke={lighterColor} strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.5" />
      <path d="M36 24 C36 20 38 18 36 14" stroke={lighterColor} strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.5" />
    </svg>
  );
};

function adjustBrightness(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + amount));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amount));
  const b = Math.min(255, Math.max(0, (num & 0x0000FF) + amount));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
